// apps/booking-frontend/src/pages/admin/DataIOPage.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@redpanda/ui';

const DataIOPage: React.FC = () => {
  const { t } = useTranslation(['pages', 'translation']);

  return (
    <div className="container mx-auto px-4 md:px-10 py-6 pb-32">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {t('pages:admin.dataIO.title')}
        </h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* 資料匯出 */}
        <div className="bg-white dark:bg-slate-800 shadow rounded-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            {t('pages:admin.dataIO.export.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t('pages:admin.dataIO.export.description')}
          </p>
          <div className="space-y-3">
            <Button
              disabled
              className="w-full opacity-50 cursor-not-allowed"
            >
              {t('pages:admin.dataIO.export.customers')}
            </Button>
            <Button
              disabled
              className="w-full opacity-50 cursor-not-allowed"
            >
              {t('pages:admin.dataIO.export.bookings')}
            </Button>
            <Button
              disabled
              className="w-full opacity-50 cursor-not-allowed"
            >
              {t('pages:admin.dataIO.export.services')}
            </Button>
          </div>
        </div>

        {/* 資料匯入 */}
        <div className="bg-white dark:bg-slate-800 shadow rounded-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            {t('pages:admin.dataIO.import.title')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {t('pages:admin.dataIO.import.description')}
          </p>
          <div className="space-y-3">
            <Button
              disabled
              className="w-full opacity-50 cursor-not-allowed"
            >
              {t('pages:admin.dataIO.import.customers')}
            </Button>
            <Button
              disabled
              className="w-full opacity-50 cursor-not-allowed"
            >
              {t('pages:admin.dataIO.import.services')}
            </Button>
            <Button
              disabled
              className="w-full opacity-50 cursor-not-allowed"
            >
              {t('pages:admin.dataIO.import.bookings')}
            </Button>
          </div>
        </div>
      </div>

      {/* 提示訊息 */}
      <div className="mt-8 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
        <h4 className="font-semibold text-yellow-900 dark:text-yellow-100 mb-2">
          {t('pages:admin.dataIO.developmentWarning.title')}
        </h4>
        <p className="text-yellow-800 dark:text-yellow-200 text-sm">
          {t('pages:admin.dataIO.developmentWarning.message')}
        </p>
      </div>
    </div>
  );
};

export default DataIOPage;
